export interface IKnownExceptionsToIgnoreCatcher {
	shouldIgnoreException(exception: Error | null | undefined): boolean;
}

/**
 * This class should catch exceptions that shouldn't make it to ExceptionLess
 */
export class KnownExceptionsToIgnoreCatcher implements IKnownExceptionsToIgnoreCatcher {
	public shouldIgnoreException(exception: Error | null | undefined): boolean {
		if (!exception) return true;

		const { isKnownJqueryUiDialogError, isResizeObserverLoopLimitExceededException } = this;

		if (isKnownJqueryUiDialogError(exception)) {
			console.warn("✋ Caught a known jquery exception.");
			return true;
		}

		// add other known exceptions here
		if (isResizeObserverLoopLimitExceededException(exception)) {
			console.warn("✋ Caught a known resizeObserver exception");
			return true;
		}

		return false;
	}

	// PAD-4360
	// https://bugs.jqueryui.com/ticket/15182
	public isKnownJqueryUiDialogError(exception: Error): boolean {
		return exception?.message?.includes("Cannot read property '_focusTabbable' of undefined") ?? false;
	}

	public isResizeObserverLoopLimitExceededException(exception: Error): boolean {
		return exception?.message?.includes("ResizeObserver loop limit exceeded") ?? false;
	}
}
